import Component from '@bythepixel/component-loader';
import { breakpoints } from '@Front/constants';
import GlideSlider from '../base';

const glideOptions = {
  breakpoints: {
    [breakpoints['break-1']]: {
      focusAt: 'center',
      dragThreshold: 120,
    },
    [breakpoints['break-2'] - 1]: {
      gap: 12.5,
      focusAt: 'center',
      dragThreshold: 120,
    },
  },
  dragThreshold: false,
  gap: 21,
  perTouch: 1,
  rewind: false,
  type: 'slider',
};

const selectors = {
  slide: '[data-comp-modal-vehicle-slider="slide"]',
};

export default class SectionModalVehicleSlider extends Component {
  static selector = '[data-comp-modal-vehicle-slider="slider"]';
  static loaderPriority = 'in-view';

  constructor(containerEl) {
    super(containerEl);

    // If in desktop view, do not initialize slider
    if (window.matchMedia('(min-width: 768px)').matches) {
      return;
    }

    this.slider = new GlideSlider(containerEl, glideOptions, selectors);

    // Glide instance of the slider
    this.glide = this.slider.getGlideSlider();

    this.initMountEvents();
    this.initSwipeAndMouseEvents();
    this.initResizeEvents();

    this.glide.mount();
  }

  /**
   * Initializes mount events for the vehicle slider container
   *
   * @return void
   */
  initMountEvents() {
    // Run these events after mounting the slider
    this.glide.on('mount.after', () => {
      this.updatePerView();
      this.slider.handleSlideIndicatorActiveState();
    });
  }

  /**
   * There are bugs with the breakpoints that require
   * the slider to be updated manually like this
   *
   * @return void
   */
  initResizeEvents() {
    this.glide.on('resize', () => {
      this.updatePerView();
      this.glide.update(glideOptions);
      this.slider.handleSlideIndicatorActiveState();
    });
  }

  /**
   * Initializes swipe and mouse movement events
   *
   * @return void
   */
  initSwipeAndMouseEvents() {
    this.glide.on('run', () => {
      this.slider.handleSlideIndicatorActiveState();
    });
  }

  /**
   * perView is a glide setting
   * It is dynamically calculated for this slider
   *
   * @return void
   */
  updatePerView() {
    const sliderWidth = this.slider.getSliderWidth();

    this.glide.update({
      perView: sliderWidth / 270,
    });
  }
}
